import React from 'react';
import { Icon } from '../icon/Icon';
import { useSpring, animated } from 'react-spring/web.cjs';

interface AccordionItemProps {
  active: boolean;
  body: any;
  disabled?: boolean;
  title: string;
  onToggle: () => void;
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  active,
  body,
  disabled,
  onToggle,
  title
}) => {
  const animateItem = useSpring({
    config: {
      tension: 200,
      friction: 10,
      clamp: true
    },
    opacity: active ? 1 : 0,
    marginTop: active ? 0 : -50
  });

  const animatedIcon = useSpring({
    config: {
      tension: 200,
      friction: 20,
      clamp: true
    },
    transform: active ? 'rotate(0deg)' : 'rotate(180deg)'
  });

  return (
    <li
      className={`ads-accordion__item ${
        active ? 'ads-accordion--active' : ''
      } ${disabled ? 'ads-accordion__disabled' : ''}`}
      aria-disabled={disabled && true}
      data-testid="ads-accordion__item"
    >
      <button
        className="ads-accordion__button"
        onClick={() => onToggle()}
        tabIndex={disabled ? -1 : 0}
        disabled={disabled && true}
        data-testid="ads-accordion__button"
      >
        {title}
        <animated.span style={animatedIcon} className="ads-accordion__icon">
          {disabled ? (
            <Icon name="arrowUpLg" color="ads-color-disabled" />
          ) : (
            <Icon name="arrowUpLg" />
          )}
        </animated.span>
      </button>
      <animated.div
        style={animateItem}
        className={`ads-accordion__body ${active ? 'ads-accordion--open' : ''}`}
        data-testid="ads-accordion__body"
      >
        {body}
      </animated.div>
    </li>
  );
};
